import TradePermitModal from 'components/modals/documentModals/TradePermitModal';
import { usePlumbingPermitV4 } from 'hooks/useDocuments';
import { useGetQueryParam } from 'hooks/useModal';
import { usePlumbingPermit } from 'hooks/usePlumbingPermit';

const PlumbingPermit = ({
  enableFetchByDocumentId = false,
}: {
  enableFetchByDocumentId?: boolean;
}) => {
  let result: any;

  if (enableFetchByDocumentId) {
    const documentId = useGetQueryParam('documentId');
    result = usePlumbingPermitV4(documentId || undefined);
  } else {
    const documentUuid = useGetQueryParam('plumbingPermit');
    result = usePlumbingPermit(documentUuid);
  }

  return (
    <TradePermitModal
      document={result.data}
      title="Plumbing Permit"
      isLoading={result.isLoading}
    />
  );
};

export default PlumbingPermit;
